<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <div style="display: flex;">
          <div style="margin-right: 5px;">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              type="danger"
              >新增
            </el-button>
          </div>
          <div>
            <el-button
              v-access:add
              icon="el-icon-download"
              @click="exportData"
              size="small"
              :disabled="isloading"
              >导出
            </el-button>
          </div>
          <div style="display: flex; margin-left:auto;">
          <div class="search-item" style="margin-right:5px;line-height:3.9">
           <label class="item-label">捐赠时间：</label>
            <el-date-picker
              v-model="timeValue"
              type="daterange"
              placeholder="选择日期"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              @change="changeTime"
            />
          </div>
            <el-input
              style="width: 290px;margin-right: 10px;"
              v-model="searchModel.searchKey"
              clearable
              :placeholder="placeholder"
            />
            <div>
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-tabs
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabsClick"
        >
          <el-tab-pane label="资金捐赠台账" name="donation">
            <el-table
              border
              hightlight-current-row
              style="width: 100%"
              :header-cell-class-name="headerRow"
              :data="listData"
              :max-height="tableMaxHeight()"
              v-loading="isloading"
            >
              <el-table-column
                prop="Id"
                label="捐赠单号"
                width="180"
              ></el-table-column>
              <el-table-column
                prop="ProjectName"
                label="捐赠项目"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="Name"
                label="捐赠者"
                :show-overflow-tooltip="true"
                width="160"
              ></el-table-column>
              <el-table-column
                prop="Amount"
                label="捐赠金额"
                width="105"
                align="right"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <span>￥{{ scope.row.Amount | rounding }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="PayType"
                label="捐赠方式"
                align="center"
                :formatter="formatterdonate"
                width="105"
              ></el-table-column>
              <el-table-column
                prop="FinishTime"
                label="捐赠时间"
                width="140"
                align="center"
              >
                <template slot-scope="scope">
                  {{ (scope.row.FinishTime * 1000) | formatDate }}
                </template>
              </el-table-column>
              <el-table-column
                prop="IsSystem"
                label="数据来源"
                align="center"
                width="100"
                :formatter="formatterIsSystem"
              ></el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                align="center"
                :formatter="formatterstatus"
                width="90"
              ></el-table-column>
              <el-table-column label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-access:read
                    @click="innerEdit(scope.row)"
                    type="text"
                    size="mini"
                    >详情
                  </el-button>
                  <el-button
                    v-access:modify
                    v-if="isShow(scope.row)"
                    @click="innerTotheAccount(scope.row)"
                    type="text"
                    size="mini"
                    >确认到账
                  </el-button>
                  <el-button
                    v-access:delete
                    v-if="isDel(scope.row)"
                    @click="innerDel(scope.row)"
                    type="text"
                    size="mini"
                    >删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <ModuleQuery
      v-if="formDataQuery"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import ModuleEdit from "@/modules/zjrc/pages/donation/donation/edit";
import ModuleQuery from "@/modules/zjrc/pages/donation/donation/query";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";
import {saveAs} from 'file-saver'
export default {
  name: "list",
  data() {
    return {
      isloading: false,
      listData: [],
      headerRow: "header-row",
      formVisible: false,
      formDataQuery: false,
      formTitle: "",
      formData: {},
      total: 0,
      currentPage: 1,
      pageSize: 15,
      searchModel: {
        searchKey: '',
        projectName: ''
      },
      projectName: "",
      projectptions: [],
      placeholder: "单号 / 捐赠项目 / 捐赠者名称",
      querydate: "",
      startdate: null,
      enddate: null,
      activeName: "donation",
      timetodonationlistData: [],
      timetodonationData: [],
      timeValue: ''
    };
  },
  filters: {
    rounding(value) {
      return value.toFixed(2);
    },
  },
  methods: {
    exportData() {
      const request = {
        startdate: this.startdate,
        enddate: this.enddate,
      }
      api.exportDonation(request).then(res => {
        if(res.data.Code === 0) {
          saveAs(res.data.Data,'资金捐赠台账导出.xls')
        }else {
          this.$message.error('导出失败')
        }
      })
    },
    changeTime(val) {
      if (val === null) {
        this.startdate = null
        this.enddate = null
      }else {
        this.startdate = val[0] / 1000
        this.enddate = val[1] / 1000
      }
      this.loadData()
    },
    cleradate() {
      this.querydate = "";
    },
    getDate() {
      if (this.querydate !== "") {
        this.startdate = this.querydate[0] / 1000;
        this.enddate = this.querydate[1] / 1000;
        this.loadData();
      }
    },
    //时间戳转换
    dateChange(value) {
      if (value.FinishTime === null) {
        return "";
      } else {
        var date = new Date(value.FinishTime * 1000);
        var y = date.getFullYear();
        var m =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return y + "-" + m + "-" + d;
      }
    },

    //tab切换
    handleTabsClick(tab, event) {
      this.currentPage = 1;
      this.searchModel = {};
      switch (tab.name) {
        case "donation":
          this.placeholder = "单号 / 捐赠项目 / 捐赠者名称";
          this.loadData();
          break;
        case "timetodonationlist":
          this.placeholder = "单号 / 捐赠项目 / 捐赠者名称";
          // this.loadTimeToDonationList();
          break;
        case "timetodonation":
          this.placeholder = "捐赠项目 / 捐赠者名称";
          // this.loadTimeToDonation();
          break;
      }
    },
    //初始化数据
    loadData() {
      this.isloading = true;
      this.searchModel.projectName = this.searchModel.projectName
        ? this.searchModel.projectName
        : "";
      this.searchModel.searchKey = this.searchModel.searchKey
        ? this.searchModel.searchKey
        : "";
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        SearchKey: this.searchModel.searchKey,
        startdate: this.startdate,
        enddate: this.enddate,
      };
      api.QueryDonation(params).then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //定期捐列表查询
    loadTimeToDonationList() {
      this.isloading = true;
      this.searchModel.searchKey = this.searchModel.searchKey
        ? this.searchModel.searchKey
        : "";
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchKey: this.searchModel.searchKey,
      };
      api.QueryTimeToDonationList(params).then((res) => {
        if (res.data.Code === 0) {
          this.total = res.data.Data.total;
          this.timetodonationlistData = res.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //定期捐用户查询
    loadTimeToDonation() {
      this.isloading = true;
      this.searchModel.searchKey = this.searchModel.searchKey
        ? this.searchModel.searchKey
        : "";
      let params = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchKey: this.searchModel.searchKey,
      };
      api.QueryTimeToDonation(params).then((res) => {
        if (res.data.Code === 0) {
          this.total = res.data.Data.total;
          this.timetodonationData = res.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    loadClick() {
      if (this.activeName === "timetodonationlist") {
        // this.loadTimeToDonationList();
      } else if (this.activeName === "timetodonation") {
        // this.loadTimeToDonation();
      }
    },
    //按钮搜索
    btnQuery() {
      this.searchModel.projectName = this.projectName;
      this.loadData();
    },
    add() {
      (this.formTitle = "新增资金捐赠"), (this.formData = {});
      this.formVisible = true;
      this.formData.Creator = this.GetCurrentUserInfo.RealName;
      this.formData.CreatorId = this.GetCurrentUserInfo.Id;
    },
    //关键字查找
    search(keyword) {
      this.searchModel.searchKey = keyword;
      this.loadData();
    },
    innerEdit(rowData) {
      switch (rowData.PayType) {
        case 1:
          rowData.PayDetailType = 1;
          break;
        case 2:
          if (rowData.TrxType === "RecvQRPayResult") {
            rowData.PayDetailType = 4;
          } else {
            rowData.PayDetailType = 5;
          }
          break;
        default:
          rowData.PayDetailType = 3;
          break;
      }
      rowData.IsInvoice = rowData.IsInvoice ? 1 : 0;

      this.formData = Object.assign({}, rowData);
      this.edit();
    },
    edit() {
      this.formTitle = "查看详情";
      this.formDataQuery = true;
    },
    //捐款方式
    formatterdonate(item) {
      //   return item.PayType === 0 ? "不需要" : "需要";
      switch (item.PayType) {
        case 1:
          return "在线银联";
        case 2:
          return "手机支付";
        case 3:
          return "线下转账";
      }
    },
    //支付状态
    formatterstatus(item) {
      switch (item.Status) {
        case 0:
          return item.PayType == 3 ? "待确认" : "待支付";
        case 1:
          return "已支付";
        case 2:
          return "已取消";
      }
    },
    //捐赠者类型
    formatterdonation(item) {
      return item.Donation === 1 ? "个人" : "企业";
    },
    //资金数据来源
    formatterIsSystem(rowData) {
      return rowData.IsSystem ? "录入" : "系统";
    },
    formCallBack(data) {
      this.formVisible = false;
      this.formDataQuery = false;
      if (data != null) {
        this.loadData();
      }
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.pageSize) {
        this.currentPage = val;
        this.loadData();
      }
    },
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    reset() {
      this.searchModel = {};
      this.projectName = "";
      this.loadData();
    },
    //确认到账
    innerTotheAccount(rowData) {
      this.$confirm("您确定资金已到账？", "确认到账", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api.UpdateContriButionStatus(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已确认到账",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
    //删除
    innerDel(rowData) {
      this.$confirm("您确定删除此资金捐赠信息？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = { Id: rowData.Id };
        api.DeleteContriBution(params).then((rep) => {
          if (rep.data.Code === 0) {
            this.$message({
              message: "已删除",
              type: "success",
            });
            this.loadData();
          } else {
            this.$message({
              message: rep.data.Message,
              type: "error",
            });
          }
        });
      });
    },
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModuleEdit,
    ModuleQuery,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    //确认到账按钮
    isShow() {
      return (rowData) => {
        return rowData.PayType == 3 && rowData.Status == 0 ? true : false;
      };
    },
    //删除按钮
    isDel() {
      return (rowData) => {
        return rowData.UserId ? false : true;
      };
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-date-editor .el-range__icon {
    line-height: 0;
}
/deep/ .el-date-editor .el-range-separator {
    line-height: 1.5;
    padding: 0;
}
/deep/ .el-date-editor .el-range__close-icon {
    line-height: 1.5;
}

/* .el-select >>> .el-input__inner {
          width: 120px;
        } */
</style>

<style>
.searchbox {
  float: left;
  margin-right: 1%;
}

.searchbox_right {
  float: right;
  margin-right: 1%;
  widows: 100%;
}

</style>
